module.exports = __webpack_public_path__ + "static/media/bgn-black.781fbafa.jpg";